/**
 * Verifica que part esté incluido en text, sin case sensitive ni acento sensitivo,
 * pero manteniendo la distinción entre 'ñ' y 'n'.
 */
export function includesLike(text: string, part: string): boolean {
  const normalizedText = removeAccents(text.toLowerCase());
  const normalizedPart = removeAccents(part.toLowerCase());

  return normalizedText.includes(normalizedPart);
}

const removeAccents = (str: string): string => {
  const accentMap: { [key: string]: string } = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u",
    ü: "u",
    à: "a",
    è: "e",
    ì: "i",
    ò: "o",
    ù: "u",
  };

  return str
    .split("")
    .map((char) => accentMap[char] || char)
    .join("");
};
